import { useEffect } from 'react'
import { PageHeader } from '@/features/invitee/components/PageHeader'
import { HelpAboutContent } from '../components/HelpAboutContent'
import { useHelpAboutContent } from '../hooks/useHelpAboutContent'

export function HelpAboutPage() {
  const { contentLoading, htmlContent } = useHelpAboutContent()

  useEffect(() => {
    document.title = 'Help / About'
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [])

  return (
    <div
      data-testid="dashboard-help-about-page"
      className="min-h-screen bg-[#f8fafc] font-sans text-slate-900 pb-12"
    >
      <PageHeader
        title="HELP & ABOUT"
        titleClassName="text-lg sm:text-xl font-bold tracking-wide text-[#1A2B4B] leading-none"
        impersonationStopDataTestId="dashboard-help-about-stop-impersonate-button"
        useApplicantImpersonationFallback
      />

      <div className="w-full px-3 sm:px-6 py-4 sm:py-8 flex flex-col gap-4 sm:gap-6">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <div className="w-full px-4 sm:px-6 lg:px-8 pb-6 sm:pb-8 pt-4 sm:pt-6">
            <HelpAboutContent
              contentLoading={contentLoading}
              htmlContent={htmlContent}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
